import React from "react";
import styled from "styled-components";

export const familyFormValues = (question = {}) => ({
  family_id: question.family?.id || "",
  family_role: question.family_role || "",
  parent_question_id: question.parent_question_id || "",
  variant_parameters_text: JSON.stringify(question.variant_parameters || {}, null, 2),
});

export const familyPayload = (form) => {
  if (!form.family_id) return { family_id: null, family_role: "", parent_question_id: null, variant_parameters: {} };
  let parameters;
  try { parameters = JSON.parse(form.variant_parameters_text || "{}"); }
  catch { throw new Error("變式參數必須是有效的 JSON 物件。"); }
  if (!parameters || typeof parameters !== "object" || Array.isArray(parameters)) throw new Error("變式參數必須是 JSON 物件。");
  return {
    family_id: form.family_id, family_role: form.family_role || "seed",
    parent_question_id: form.family_role === "variant" ? form.parent_question_id || null : null,
    variant_parameters: form.family_role === "variant" ? parameters : {},
  };
};

export default function QuestionFamilyFields({ families, form, onChange }) {
  return <Fields>
    <label>題族<select value={form.family_id || ""} onChange={(event) => onChange({ family_id: event.target.value, family_role: event.target.value ? "seed" : "", parent_question_id: "", variant_parameters_text: "{}" })}>
      <option value="">未歸題族</option>
      {families.filter((family) => family.is_active || family.id === form.family_id).map((family) => <option key={family.id} value={family.id}>{family.name}{family.is_active ? "" : "（已停用）"}</option>)}
    </select></label>
    {form.family_id && <label>族內角色<select value={form.family_role || "seed"} onChange={(event) => onChange({ family_role: event.target.value, ...(event.target.value === "seed" ? { parent_question_id: "", variant_parameters_text: "{}" } : {}) })}><option value="seed">母題</option><option value="variant">變式題</option></select></label>}
    {form.family_id && form.family_role === "variant" && <>
      <label>母題 UUID<input value={form.parent_question_id || ""} onChange={(event) => onChange({ parent_question_id: event.target.value.trim() })} /></label>
      <label>變式參數<textarea rows={3} value={form.variant_parameters_text || "{}"} onChange={(event) => onChange({ variant_parameters_text: event.target.value })} /></label>
    </>}
  </Fields>;
}

const Fields = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr)); gap: 12px; grid-column: 1 / -1;
  label { display: grid; gap: 6px; font-size: 13px; min-width: 0; }
  input, select, textarea { width: 100%; min-width: 0; box-sizing: border-box; padding: 9px; font: inherit; color: var(--app-text); background: var(--app-input-bg, #fff); border: 1px solid var(--app-border); border-radius: 6px; }
  textarea { resize: vertical; font-family: monospace; }
`;
